export default __webpack_public_path__ + "static/media/business-900.3d2552cd.png";